import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';

export const isTablet = (): boolean => {
    return !isServerRendering() && window.innerWidth >= 768 && window.innerWidth < 1024;
};
